import { useState } from 'react';
import { Input } from '.';
import type { InputProps } from './Input';

interface Props
  extends Omit<InputProps, 'type' | 'rightIcon' | 'onRightIconClick'> {
  label: string;
  value: string;
}

export const PasswordInput = ({ label, value, onChange, ...props }: Props) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Input
      type={showPassword ? 'text' : 'password'}
      rightIcon="ri-eye-line"
      onRightIconClick={() => setShowPassword((prev) => !prev)}
      label={label}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};
